"use client";

import { captureException } from "@sentry/nextjs";
import { Inter } from "next/font/google";
import { useEffect } from "react";

// This page replaces the root layout, so it loads the app face itself.
const inter = Inter({ subsets: ["latin", "latin-ext"], display: "swap" });

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    // Report the error to Sentry
    captureException(error);
  }, [error]);

  return (
    <html lang="en">
      <body className={inter.className}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            padding: "20px",
          }}
        >
          <h2>Ugh, unexpected - something went wrong!</h2>
          <p style={{ color: "#666", marginBottom: "20px" }}>We've been notified about this error and are working to fix it.</p>
          <button
            onClick={reset}
            style={{
              padding: "10px 20px",
              backgroundColor: "#0070f3",
              color: "white",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
            type="button"
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
